import { Typography } from 'antd';
import styled from '@emotion/styled';
import { typeStyle } from 'constants/typography';

type Overflow = 'wrap' | 'scroll';

const blockLayout = (overflow?: Overflow) => `
  display: block;
  padding: 0.75em;
  white-space: ${overflow === 'scroll' ? 'pre' : 'pre-wrap'};
  word-break: ${overflow === 'scroll' ? 'normal' : 'break-all'};
`;

const codeLayout = (overflow?: Overflow) =>
  overflow === 'scroll'
    ? 'display: block; overflow: auto; max-height: 360px;'
    : 'display: flex; align-items: center; justify-content: space-between;';

const CopyableCodeBlock = styled(Typography.Text, {
  shouldForwardProp: prop => prop !== 'overflow' && prop !== 'inline'
})<{
  overflow?: Overflow;
  /** Sits inside a line of text: no block display, padding or wrapping of its own. */
  inline?: boolean;
}>`
  ${({ inline, overflow }) => (inline ? '' : blockLayout(overflow))}

  /* Doubled to beat antd's \`.ant-typography code\`, which sets its own 85% size and family. */
  && code {
    ${typeStyle.code}
    ${({ inline, overflow }) => (inline ? '' : codeLayout(overflow))}
  }
`;

CopyableCodeBlock.defaultProps = {
  code: true,
  copyable: true
};

export default CopyableCodeBlock;
